const notify = (notifObj) => {
  if (!window.Notification) {
    console.log('Browser does not support notifications.');
  } else {
    /* eslint-disable no-lonely-if */
    // check if permission is already granted
    if (Notification.permission === 'granted') {
      // show notification here
      const notification = new Notification('Interact', notifObj);
      notification.onclick = function () {
        window.open(notifObj.url);
      };
    } else {
      // request permission from user
      Notification.requestPermission()
        .then(function (p) {
          if (p === 'granted') {
            // show notification here
            const notification = new Notification('Interact', notifObj);
            notification.onclick = function () {
              window.open(notifObj.url);
            };
          } else {
            console.log('User blocked notifications.');
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    }
  }
};

export default { notify };
